export function useOnboardingVideos() {
  const videos = [
    {
      title: 'Welcome to FOREVER',
      length: 81_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/hype/hype-f3_welcome.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/hype/hype-f3_welcome.jpg'
    },
    {
      title: 'Facial Recognition',
      length: 50_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/hype/hype-facial_recongition.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/hype/hype-facial_recongition.jpg'
    },
    {
      title: 'How To: Upload Files to FOREVER',
      length: 61_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-uploading.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-uploading.jpg'
    },
    {
      title: 'How To: People',
      length: 93_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-people.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-people.jpg'
    },
    {
      title: 'How To: Groups & Sharing',
      length: 135_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-groups_and_sharing.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-groups_and_sharing.jpg'
    },
    {
      title: 'How To: Filter Your Content',
      length: 169_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-filter_your_content.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-filter_your_content.jpg'
    },
    {
      title: 'How To: Facial Recognition',
      length: 227_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-facial_recongition.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-facial_recongition.jpg'
    },
    {
      title: 'How To: Declutter',
      length: 76_000,
      url: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-declutter.mp4',
      poster: 'https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/how_to-declutter.jpg'
    }
  ];

  const homeViewVideos = videos.slice(0, 8);

  return {
    videos,
    homeViewVideos
  };
}
